export default function Safety() {
  const challenges = [
    {
      icon: 'ri-group-line',
      title: 'Community Relations',
      description: 'Raw material procurement from mines in rural areas can be affected by community strikes, causing delivery delays and raw material shortages at the processing plant.',
      solution: 'Building strong relationships with local communities and pursuing exclusive offtake agreements to ensure consistent supply.'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Power Supply',
      description: 'Eskom load shedding stages force mines without backup generators to stop operations completely until power is restored, impacting raw material supply.',
      solution: 'Diversifying supplier base across multiple mines and maintaining strategic raw material inventory at the processing plant.'
    },
    {
      icon: 'ri-truck-line',
      title: 'Logistics Coordination',
      description: 'Managing transportation from multiple mine sites (70-120km radius) requires careful coordination to maintain consistent feed to the processing plant.',
      solution: 'Strategic partnerships with local transporters and optimized logistics planning to ensure reliable delivery schedules.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-6 font-['Montserrat']">
            <span className="text-black">OPERATIONAL </span>
            <span className="text-[#8B1538]">CHALLENGES</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto font-['Lato']">
            Understanding and addressing the challenges in chrome processing operations
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {challenges.map((challenge, index) => (
            <div
              key={index}
              className="bg-[#F5F7FA] rounded-2xl p-8 hover:shadow-xl transition-all duration-300"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#8B1538] to-[#6B6B6B] rounded-xl flex items-center justify-center mb-6">
                <i className={`${challenge.icon} text-white text-3xl`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-[#2C3E50] mb-4">
                {challenge.title}
              </h3>
              
              <p className="text-gray-600 mb-4 leading-relaxed">
                <strong className="text-[#8B1538]">Challenge:</strong> {challenge.description}
              </p>
              
              <p className="text-gray-600 leading-relaxed">
                <strong className="text-[#6B6B6B]">Solution:</strong> {challenge.solution}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#8B1538] to-[#6B6B6B] rounded-3xl overflow-hidden">
          <div className="grid md:grid-cols-2">
            <div className="p-12 flex flex-col justify-center">
              <h3 className="text-4xl font-bold text-white mb-6 font-['Montserrat']">
                Commitment to Excellence
              </h3>
              <p className="text-lg text-white/90 mb-6 leading-relaxed">
                Despite operational challenges, TMI maintains its commitment to delivering quality chrome products on time. Our experienced management team constantly monitors market trends and adapts strategies to ensure consistent supply to our clients.
              </p>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-white mb-2">Quality Assurance</h4>
                    <p className="text-white/80">Consistent quality control throughout the beneficiation process</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-white text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-white mb-2">Reliable Delivery</h4>
                    <p className="text-white/80">JIT supply model ensures timely delivery to clients</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-team-line text-white text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-white mb-2">Strong Relationships</h4>
                    <p className="text-white/80">Building trust with suppliers, clients, and communities</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="relative h-[500px]">
              <img 
                src="https://static.readdy.ai/image/3b8ad55d4ff58d61aa412f5935e39846/03cae614040a929a65775a2758c29218.jpeg"
                alt="Quality Control"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}